<template>
  <div>
    <div v-for="streetName in Object.keys(properties)" :key="streetName">
      <div
        v-for="streetNumber in Object.keys(properties[streetName])"
        :key="streetName + streetNumber"
        :class="{
          'property__address--open': selectedStreet === streetName + streetNumber || Object.keys(properties[streetName]).length === 1,
        }"
        class="property__address"
      >
        <div class="property__address__group">
          <div class="property__address__group__header" @click="toggleStreet(streetName + streetNumber)">
            {{ streetName }}, {{ streetNumber }}
            <i v-if="Object.keys(properties[streetName]).length > 1" class="property__address__group__header__plus-icon" />
          </div>
        </div>
        <ul class="property__address__list formulate-input--small">
          <li
            class="property__address__container"
            v-for="(property, i) in properties[streetName][streetNumber]"
            :key="i"
            :id="'property-' + property.number"
            @click="selectedOption(property)"
          >
            <div v-if="showFloorAndDoor(property.address.floor, property.address.door)" class="property__address__entry">
              <p>Bloque: {{ property.address.building || '-' }}</p>
              <p>Escalera: {{ property.address.ladder || '-' }}</p>
              <p>Planta: {{ getParsedValue(property.address.floor) }}</p>
              <p>Puerta: {{ getParsedValue(property.address.door) }}</p>
            </div>
            <div v-else class="property__address__entry">
              <p>Bloque: {{ property.address.building || '-' }}</p>
              <p>Escalera: {{ property.address.ladder || '-' }}</p>
              <p>Id: {{ property.number }}</p>
              <p>Referencia: {{ property.ref }}</p>
            </div>

            <FormulateInput
              class="formulate-input--small"
              type="radio"
              v-model="property.selected"
              :value="property.ref"
              :name="'property-' + property.ref"
              @input="selected(property)"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedProperty: {
      type: Object,
    },
    properties: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      selectedStreet: null,
    };
  },
  created() {
    if (!!this.selectedProperty) {
      this.selected(this.selectedProperty);
    } else {
      const property = this.allProperties[0];

      property.selected = true;
      this.selected(property);
    }
  },
  computed: {
    allProperties() {
      let properties = [];

      Object.keys(this.properties).forEach(streetName => {
        Object.keys(this.properties[streetName]).forEach(streetNumber => {
          properties = [...properties, ...this.properties[streetName][streetNumber]];
        });
      });

      return properties;
    },
  },
  methods: {
    selected(val) {
      if (!!val.selected) {
        this.allProperties.forEach(function(property) {
          if (!!property.selected && property.ref != val.ref) {
            property.selected = null;
          }
        });
        this.$emit('change', val);
      }
    },
    showFloorAndDoor(floor, door) {
      return this.getParsedValue(floor) !== '-' || this.getParsedValue(door) !== '-';
    },
    getParsedValue(val) {
      if (val === '' || val === null) {
        return '-';
      }

      return val;
    },
    toggleStreet(key) {
      if (this.selectedStreet === key) {
        this.selectedStreet = null;
        return;
      }

      this.selectedStreet = key;
    },
    selectedOption(property) {
      this.selected(property);
      property.selected = true;
    },
  },
};
</script>
